import React from 'react';
import StatusBadge from '../shared/StatusBadge';
import PermissionGate from '../shared/PermissionGate';
import { PERMISSIONS } from '../../constants/permissionMappings';

const VendorsTable = ({ vendors, onEdit, onDelete, onCreateClick }) => {
  if (vendors.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow-md p-6 text-center">
        <p className="text-gray-500 mb-4">No vendors found. Create your first vendor to get started.</p>
        <PermissionGate permission={PERMISSIONS.vendors.create}>
          <button
            onClick={onCreateClick}
            className="px-4 py-2 bg-brand text-white rounded-lg hover:bg-brand-hover font-semibold transition-colors"
          >
            Create Vendor
          </button>
        </PermissionGate>
      </div>
    );
  }

  const handleDelete = async (vendorId) => {
    if (window.confirm('Are you sure you want to delete this vendor?')) {
      await onDelete(vendorId);
    }
  };

  const getContactName = (vendor) => {
    if (vendor.firstName || vendor.lastName) {
      return `${vendor.firstName || ''} ${vendor.lastName || ''}`.trim();
    }
    return '-';
  };

  return (
    <div className="bg-white shadow-md rounded-lg overflow-hidden">
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Name
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Contact
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Email
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Phone
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Status
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Created
              </th>
              <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {vendors.map(vendor => (
              <tr key={vendor.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm font-medium text-gray-900">{vendor.vendorName}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {getContactName(vendor)}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {vendor.email || '-'}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {vendor.phone || '-'}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <StatusBadge 
                    type="vendor_status" 
                    value={vendor.isActive !== false}
                    size="xs"
                  />
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {new Date(vendor.createdAt).toLocaleDateString()}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                  <PermissionGate permission={PERMISSIONS.vendors.edit}>
                    <button
                      onClick={() => onEdit(vendor)}
                      className="text-brand hover:text-brand-hover mr-4 transition-colors"
                    >
                      Edit
                    </button>
                  </PermissionGate>
                  <PermissionGate permission={PERMISSIONS.vendors.delete}>
                    <button
                      onClick={() => handleDelete(vendor.id)}
                      className="text-red-600 hover:text-red-900 transition-colors"
                    >
                      Delete
                    </button>
                  </PermissionGate>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default VendorsTable;